import React, { Component } from "react";

class CSVProcessingOnSite extends Component {
  render() {
    const { onCancel, progress, progressStage } = this.props;
    const hasProgress = typeof progress === "number" || progressStage;

    return (
      <div className="flex flex-col gap-6 w-[44.938rem] h-[29.375rem] bg-white justify-center rounded-xl items-center z-100 shadow-lg px-10">
        {/* Spinner */}
        <div className="relative flex items-center justify-center w-16 h-16">
          <div className="absolute w-full h-full border-4 border-blue-100 rounded-full"></div>
          <div className="absolute w-full h-full border-4 border-t-blue-500 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
        </div>
        {/* Text */}
        <div className="flex flex-col items-center gap-2 text-center">
          <p className="font-inter font-semibold text-gray-800 text-xl">
            Processing your file
          </p>
          <p className="font-inter text-sm text-gray-400">
            {progressStage || (hasProgress ? "Starting analysis..." : "Please wait patiently, this may take a moment")}
          </p>
        </div>
        {/* Progress bar */}
        {hasProgress && (
          <div className="w-full max-w-md">
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-blue-500 h-3 rounded-full transition-all duration-500 ease-out"
                style={{ width: `${Math.min(progress, 100)}%` }}
              ></div>
            </div>
            <p className="text-center text-sm text-gray-500 mt-2 font-inter">
              {progress}%
            </p>
          </div>
        )}
        {/* Cancel button */}
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="mt-2 px-6 py-2 rounded-lg border border-gray-200 text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-700 hover:border-gray-300 transition-colors font-inter"
          >
            Continue Working
          </button>
        )}
      </div>
    );
  }
}

export default CSVProcessingOnSite;
